'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../../analytics/index');

var _Canvas = require('../../canvas/Canvas');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Utils


// Constants


exports.default = function (DecoratedComponent) {
    var ElementResizeDecorator = function (_React$Component) {
        _inherits(ElementResizeDecorator, _React$Component);

        function ElementResizeDecorator(props) {
            _classCallCheck(this, ElementResizeDecorator);

            var _this = _possibleConstructorReturn(this, (ElementResizeDecorator.__proto__ || Object.getPrototypeOf(ElementResizeDecorator)).call(this, props));

            _this.setTempElementSize = function (size) {
                _this.setState({ size: size });
                _this.setIsResizing(true);
            };

            _this.setElementSize = function (size) {
                var _this$props = _this.props,
                    element = _this$props.element,
                    dispatchUpdateElement = _this$props.dispatchUpdateElement;


                _this.setState({ size: null });
                dispatchUpdateElement({ id: element.get('id'), changes: { width: Math.round(size) } });
                (0, _index.analyticsEvent)('resized-element');
                _this.setIsResizing(false);
            };

            _this.setIsResizing = function (isResizing) {
                if (_this.state.isResizing === isResizing) return;

                _this.setState({ isResizing: isResizing });
                var canvasElement = document.getElementById(_Canvas.CANVAS_ELEMENT_ID);
                _this.state.isResizing ? canvasElement.classList.add('resizing-element') : canvasElement.classList.remove('resizing-element');
            };

            _this.state = { size: null, isResizing: false };
            return _this;
        }

        /**
         * A bit hacky, but prevents the need to pass a reference to the canvas down to every component.
         */


        _createClass(ElementResizeDecorator, [{
            key: 'render',
            value: function render() {
                var _state = this.state,
                    size = _state.size,
                    isResizing = _state.isResizing;


                return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
                    tempSize: size,
                    isResizing: isResizing,
                    setElementSize: this.setElementSize,
                    setTempElementSize: this.setTempElementSize }));
            }
        }]);

        return ElementResizeDecorator;
    }(_react2.default.Component);

    ElementResizeDecorator.propTypes = {
        element: _propTypes2.default.object,
        dispatchUpdateElement: _propTypes2.default.func
    };

    return ElementResizeDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/resizing/elementResizeDecorator.js
// module id = 2006
// module chunks = 0